import * as crypto from 'crypto';

export function lowerFirstLetter(string: string): string {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export function upperFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export async function sha256(string: string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
}

export function replaceAllStringsInText(
  text: string,
  items: [searchValue: string, replaceValue: string][]
) {
  let modifiedText = text;
  items.forEach((item) => {
    modifiedText = modifiedText.replaceAll(item[0], item[1]);
  });

  return modifiedText;
}

export function fullPathToArray(fullPath: string) {
  if (!fullPath) return [];

  // If it starts with a slash, remove it before splitting
  if (fullPath.startsWith('/')) {
    return fullPath.substring(1).split('/');
  }

  // If it doesn't contain a slash, return as single-element array
  if (!fullPath.includes('/')) {
    return [fullPath];
  }

  // Otherwise, split by slash
  return fullPath.split('/');
}
